// Single Product page customer Review Response
console.log("tp-empty-check");
var tpWidget = document.querySelector('.product-page-tp-widget');
if( tpWidget )
{
    console.log("tp-empty-check: widget found");
    var templateId = tpWidget.getAttribute("data-template-id");
    var businessunitId = tpWidget.getAttribute("data-businessunit-id");
    var sku = tpWidget.getAttribute("data-sku");
    var TPURL = 'https://widget.trustpilot.com/trustbox-data/'+ templateId +'?businessUnitId='+ businessunitId +'&locale=en-GB&sku='+ sku +'&reviewsPerPage=10&reviewLanguages=en';
    console.log("tp-empty-check: " + TPURL);
    fetch(TPURL)
        .then(
            response => response.json()
        ).then(
        response => {
            console.log(response);
            console.log(response.productReviews.reviews.length);
            if(response.productReviews.reviews.length > 0){
                document.querySelector( ".trustpilot-accordion" ).classList.remove( "hidden" );
            }
        }
    );
}